<template>
  <div class="box">
    <div class="login">
      <div class="lt">
        <div class="lt_t">
          <!-- <img src="../../assets/images/login_logo.png" alt="logo"> -->
        </div>
        <div class="lt_b">
          <!-- <img src="../../assets/images/login_img.png"> -->
        </div>
      </div>
      <div class="rt">
        <div class="rt_f">
          <div class="tit_1">渠道订单系统</div>
          <div class="tit_2" style="color: #666; font-weight: bold">
            让工作更高效的完成
          </div>
          <div class="rt_l">
            <el-form
              class="login-form"
              :rules="loginformrules"
              ref="loginformref"
              :model="loginform"
            >
              <el-form-item prop="userName">
                <el-input
                  prefix-icon="el-icon-user"
                  v-model="loginform.userName"
                  placeholder="请输入账号名称"
                ></el-input>
              </el-form-item>
              <el-form-item prop="passWord">
                <el-input
                  prefix-icon="el-icon-key"
                  type="passWord"
                  v-model="loginform.passWord"
                  placeholder="请输入登录密码"
                ></el-input>
              </el-form-item>
              <el-form-item class="login-btn">
                <el-button type="primary" round @click="login">登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { Login } from '@/api/api2'
import _ from 'underscore'
export default {
  data() {
    return {
      loginform: {
        userName: '',
        passWord: '',
        validCode: '',
      },
      captchaScr: '',
      curTime: '',
      loginformrules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        passWord: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
    }
  },
  created() {},
  methods: {
    login: _.debounce(function () {
      this.$refs.loginformref.validate((valid) => {
        if (!valid) return false
        let params = new URLSearchParams()
        params.append('username', this.loginform.userName)
        params.append('password', this.loginform.passWord)
        Login(params)
          .then((res) => {
        
            if (res.code == 201) {
              sessionStorage.setItem('token', res.data.token)
              sessionStorage.setItem('id', res.data.user.id)
              sessionStorage.setItem('role', res.data.user.role)
              sessionStorage.setItem('username', res.data.user.username)
              this.$router.replace({ path: '/home' })
              this.$message.success('登录成功')
            } else {
            }
          })
          .catch((err) => {
            if (err.request.status == 400) {
              this.$message.error('账号密码错误！')
            }
          })
      })
    }, 300),
    register() {
      this.$router.push({ path: '/register' })
    },
    // 获取验证码
    getCaptcha() {
      let params = {
        timeStamp: this.curTime,
      }
      captcha(params).then((res) => {
        this.captchaScr = res
      })
    },
    changeCaptcha() {
      this.loginform.validCode = ''
      this.curTime = new Date().getTime()
      this.getCaptcha()
    },
  },
}
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  min-width: 1200px;
  height: 100%;
  background: url('../../assets/images/login_bg.jpg') no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.login {
  width: 70%;
  min-width: 1000px;
  height: 750px;
  position: relative;
  left: 200px;
  top: 60px;
  // background: url('../../assets/images/login_form.png') no-repeat;
  // background-size: 100% 100%;
  // background-color: #fff;
  display: flex;
  .lt {
    width: 60%;
    height: 100%;
    .lt_t {
      width: 100%;
      height: 200px;
      img {
        width: 190px;
        height: 118px;
        margin-top: 56px;
        margin-left: 110px;
      }
    }
    .lt_b {
      width: 100%;
      height: 550px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: inline-block;
        width: 522px;
        height: 424px;
      }
    }
  }
  .rt {
    width: 40%;
    height: 100%;
    display: flex;
    align-items: center;
    .rt_f {
      width: 80%;
      height: 60%;
      // background: red;
      .tit_1 {
        font-size: 38px;
        font-weight: bold;
      }
      .tit_2 {
        margin-top: 12px;
        color: #c0c4cc;
      }
      .rt_l {
        margin-top: 50px;
      }
    }
  }
}
.login-form {
  position: relative;
  top: 20px;
  // width: 485px;
  .validImg {
    width: 100%;
    height: 40px;
    cursor: pointer;
  }
}
.zhuce {
  color: rgb(64, 158, 255);
  cursor: pointer;
}
.zhuce:hover {
  text-decoration: underline;
}
.login-btn {
  margin-top: 50px;
  margin-left: 10px;
  /deep/ .el-button {
    width: 100%;
  }
}
.login-buttom {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  text-align: center;
  .icp {
    margin-top: 10px;
  }
  .ipcword:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
.rt_l /deep/ .el-input__inner {
  border: 0;
  border-bottom: 1px solid #c0c4cc;
  border-radius: 0;
}
</style>


// WEBPACK FOOTER //
// src/view/login/login.vue